import React, { useState } from 'react';
import '../style/BookingStyles.css';

function BookingComponent() {

  return (
    <div className="jobs-container">
      <div className="jobs-content">
        <div className="requirements-card">
          <h2>Additional Note</h2>
          <ul>
            <li>Please call 30 minutes ahead</li>
            
          </ul>
          
        </div>

        <div className="contact-info-card">
          <h2>Contact Information</h2>

          <div className="info-item">
            <i className="fa-solid fa-phone"></i>
            <p>(469) 376-0101</p>
          </div>

          <div className="info-item">
            <i className="fa-solid fa-location-dot"></i>
            <p>102 S Old Rail Rd, Kaufman, TX 75142</p>
          </div>

          <div className="info-item">
            <i className="fa-solid fa-envelope"></i>
            <p>queennailscs@gmail.com</p>
          </div>



          <div className="info-item">
            <i className="fa-solid fa-clock"></i>
            <div>
              <p>Monday - Friday: 10 AM - 7 PM</p>
              <p>Saturday: 9 AM - 6 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </div>

          <div className="walk-in">
            <p>Walk-in welcome!</p>
          </div>
        </div>
      </div>

      

    </div>
  );
}

export default BookingComponent;